import React, { forwardRef } from 'react';

import MUIStepper, {
  StepperProps as MUIStepperProps,
} from '@material-ui/core/Stepper';

interface StepperProps extends MUIStepperProps {}

const Stepper = forwardRef<HTMLDivElement, StepperProps>((props, ref) => {
  return <MUIStepper {...props} ref={ref} />;
});

Stepper.displayName = 'Stepper';

export default Stepper;
